/**
 * Textes fixes des portails client (M04, M07, X13, X14). Vouvoiement, signature « Cabinet MAAT », aucun emoji.
 * Les libellés d'ÉTAPES ne sont pas ici : ils viennent des données (`PortalHome.steps[].label`, REF-LIB). Ce fichier est une
 * donnée versionnée : tout changement de texte incrémente `VERSION_LIBELLES`.
 */
export const VERSION_LIBELLES = '2026-10-25.1';

export const TEXTES = {
  chargement: 'Chargement de votre dossier en cours…',
  chargementChoix: 'Chargement de vos choix en cours…',
  dossierVide: 'Votre dossier est en cours d’ouverture. Le Cabinet MAAT vous écrira dès la première étape.',
  erreurInconnue: 'Une erreur est survenue. Réessayez dans un instant ; si elle persiste, contactez le Cabinet MAAT.',
  reessayer: 'Réessayer',

  parcours: 'Mon parcours',
  progression: 'Progression du dossier',
  actionUnique: 'Une seule chose à faire',
  rienAFaire: 'Rien à faire pour le moment. Nous vous écrirons sur WhatsApp à la prochaine étape.',
  demandeFaite: 'C’est noté : le Cabinet MAAT s’en occupe.',
  signatureAction: 'Le Cabinet MAAT vous écrira sur WhatsApp pour cette étape.',
  voirArbre: 'Voir mon arbre',

  famille: 'Ma famille',
  familleExplication:
    'Vous ne voyez les coordonnées d’une personne que si elle a accepté de les partager. Vous ne voyez que votre branche de la famille.',
  familleVide: 'Nous recherchons encore les membres de votre branche. Nous vous écrirons dès que ce sera fait.',
  aConfirmer: 'à confirmer',
  decede: 'décédé',

  choix: 'Mes choix',
  gererChoix: 'Gérer mes consentements et mes données',
  renonciationBouton: 'Je ne veux pas hériter : comprendre la renonciation',

  participation: 'Ma participation à l’accompagnement du cabinet',
  aJour: 'Vous êtes à jour',
  aJourExplication: 'Rien à régler pour le moment. Nous vous préviendrons avant la prochaine étape qui demande un paiement.',
  voirRecus: 'Voir mes reçus',
  resteDu: 'Reste à régler',
  prochaineEcheance: 'Prochaine échéance',
  partNotaire: 'La part liée au notaire sera connue après l’estimation.',

  echanges: 'Mes échanges avec le cabinet',
  echangesVide: 'Aucun échange pour le moment.',
  echangesPanne: 'Vos échanges ne peuvent pas s’afficher pour le moment.',
} as const;

export const MODALE_RENONCIATION = {
  titre: 'Renoncer à la succession : ce qu’il faut savoir',
  compensationTitre: 'Première possibilité : la compensation en foncier',
  compensationTexte:
    'Avant toute décision, sachez que vous pouvez demander à recevoir un bien foncier en compensation de vos droits, ou à compenser une avance. Le Cabinet MAAT vous l’explique sans engagement.',
  renonciationTitre: 'La renonciation',
  renonciationTexte:
    'Renoncer est un choix parmi d’autres. Il est définitif, il se fait devant le notaire et il concerne aussi votre propre branche. Aucune de ces possibilités n’est meilleure qu’une autre par principe : tout dépend de votre situation.',
  contact: 'Pour en parler, répondez simplement à notre message WhatsApp. Cabinet MAAT.',
  fermer: 'Fermer',
} as const;

export const TEXTES_M07 = {
  titre: 'Mes données',
  introduction: 'Vos informations servent uniquement à votre dossier de succession. Vous décidez de ce que votre famille peut voir.',
  canal: 'Canal pour me joindre',
  quiVoit: 'Qui voit vos informations',
  quiVoitTexte: 'Le Cabinet MAAT, et le notaire pour les actes.',
  datation: 'Vos choix sont enregistrés avec leur date. Vous pouvez les changer à tout moment.',
  enregistrer: 'Enregistrer mes choix',
  enregistres: 'Vos choix sont enregistrés.',
  copie: 'Demander une copie de mes données',
  suppression: 'Demander la suppression de mes données',
  confirmerSuppression: 'Confirmer la demande de suppression',
  confirmationSuppression: 'Cette demande sera examinée par le Cabinet MAAT. Souhaitez-vous la confirmer ?',
  annuler: 'Annuler',
  demandeEnregistree: 'Votre demande est enregistrée. Le Cabinet MAAT vous répondra.',
  le: 'choix du',
  jamais: 'pas encore de choix enregistré',
} as const;

export type FinaliteAffichee = 'contact_cabinet' | 'partage_numero_famille' | 'partage_adresse_famille';

/** Consentement détaillé (#14) : le numéro et l'adresse sont deux choix séparés. */
export const FINALITES: readonly { finalite: FinaliteAffichee; libelle: string }[] = [
  { finalite: 'contact_cabinet', libelle: 'Le Cabinet MAAT peut me contacter' },
  { finalite: 'partage_numero_famille', libelle: 'Ma famille peut voir mon numéro' },
  { finalite: 'partage_adresse_famille', libelle: 'Ma famille peut voir mon adresse' },
];

export type CanalChoisi = 'whatsapp' | 'email' | 'telephone' | 'courrier';

export const CANAUX: readonly { canal: CanalChoisi; libelle: string }[] = [
  { canal: 'whatsapp', libelle: 'WhatsApp' },
  { canal: 'telephone', libelle: 'Téléphone' },
  { canal: 'email', libelle: 'E-mail' },
  { canal: 'courrier', libelle: 'Courrier' },
];

export const ETATS_ANNONCES = { fait: 'terminée', courant: 'en cours', a_venir: 'à venir' } as const;
